import React from 'react';
import { Box, Button, Select, MenuItem } from '@mui/material';
import { Check, Help, Close, KeyboardArrowDown } from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { DocumentActionsProps } from '../types/contractor.types';
import { Document } from '../types/contractor.types';

interface DocumentActionsExtendedProps extends DocumentActionsProps {
  documents: Document[];
  selectedDocumentId: number | null;
  onDocumentSelect: (documentId: number) => void;
}

const DocumentActions: React.FC<DocumentActionsExtendedProps> = ({
  documents,
  selectedDocumentId,
  onDocumentSelect,
  onApprove,
  onClarify,
  onReject,
  onDownload,
  onVerify
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Select
        value={selectedDocumentId || ''} 
        onChange={(e) => onDocumentSelect(e.target.value as number)}
        sx={{ minWidth: 120, borderRadius: '8px' }}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return <em>Select a document</em>;
          const doc = documents.find(d => d.documentId === selected);
          return doc ? `${doc.type} (ID: ${doc.documentId})` : 'Unknown';
        }}
      >
        {documents.map((doc) => (
          <MenuItem key={doc.documentId} value={doc.documentId}>
            {`${doc.type} (ID: ${doc.documentId})`}
          </MenuItem>
        ))}
      </Select>
      
      <Button 
        variant="contained" 
        sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY, minWidth: '40px' }}
        onClick={onDownload}
        title="Download Document"
      >
        <KeyboardArrowDown />
      </Button>
      
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: '#008c12', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}
          onClick={onApprove}
        >
          <Check /> APPROVE
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#96a700', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}
          onClick={onClarify}
        >
          <Help /> CLARIFY
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#ee6262', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}
          onClick={onReject}
        >
          <Close /> REJECT
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY, color: 'white', display: 'flex', alignItems: 'center', gap: 1, ml:2 }}
          onClick={onVerify}
        >
          VERIFY
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentActions;